/* Passthrough plan runs: a plan run executes in the person's own harness on a desktop app and is paid by the
   person's provider plan. Pieve has no desktop app; these names remain only for the thread lane and prompts
   that still recognize such runs. */
export const PIEVE_PLAN_RUN_LANE = 'desktop_harness';

export const PIEVE_HARNESS_CLAUDE_CODE = 'claude_code';

/* Where a person's passthrough switches live in main.user_pref.prefs. Whole-settings saves keep their stored
   values. */
export const PIEVE_PASSTHROUGH_USER_PREF_ROOT = 'pievePassthrough';
